import React from 'react';
import { Card, Typography, Button, Image, Grid, Divider } from 'antd';
import '../../../Styles/Linkages&Outreach.css';
import image from "../../../Assets/Linkages/awareness.jpeg"
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;


const SpaceAwarenessProgram = () => {
  const screens = useBreakpoint();

  return (
    <div className="space-awareness-container">
      <Card className="space-awareness-card" bordered={false} >
        <div className="content-wrapper">
          <div className="text-section">
             <Title level={2} className="section-title">Space Awareness & Outreach</Title>
            <Divider className="ncgsa-divider" />
            <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }}  className="description">
NCGSA conducts a dynamic space awareness and outreach program designed to engage individuals of all ages through a variety of educational and interactive platforms. By offering targeted school initiatives, specialized workshops, trainings, competitions and seminars, the Centre aims to deepen public understanding of space science technology and its applications.            </Paragraph>
     <Link to="/events">
       <Button className="view-all-btn" type="primary" shape="round">
         View All 
       </Button>
     </Link>
          </div>
          <div className="image-section">
            <Image
              src={image} 
              alt="Space Awareness"
              className="program-image"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SpaceAwarenessProgram;
